import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Users } from "lucide-react";
import { api } from "../lib/api";

export const UsersPanel = () => {
  const [users, setUsers] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => setUsers([]));
  }, []);
  if (!users) return null;
  return (
    <section data-testid="admin-users-panel" className="space-y-3 fade-up">
      <h2 className="font-heading text-lg font-semibold flex items-center gap-2"><Users className="w-5 h-5 text-[#E67E22]" /> Usuários cadastrados ({users.length})</h2>
      <div className="rounded-xl border border-[#2D333F] bg-[#181B21] overflow-x-auto">
        <table data-testid="admin-users-table" className="w-full text-sm">
          <thead className="bg-[#13151B] text-[#9CA3AF] font-mono text-[11px] uppercase">
            <tr>{["Nome", "E-mail", "Telefone", "Ambientes"].map((h) => <th key={h} className="text-left px-4 py-2">{h}</th>)}</tr>
          </thead>
          <tbody>
            {users.map((u, i) => (
              <tr key={u.id} data-testid={`admin-user-row-${i}`} onClick={() => nav(`/admin/usuario/${u.id}`)} title="Ver projetos do cliente"
                className="border-t border-[#2D333F] cursor-pointer hover:bg-[#21252F] transition-colors">
                <td className="px-4 py-2 font-medium">{u.name}</td>
                <td data-testid={`admin-user-email-${i}`} className="px-4 py-2 cursor-text select-all" onClick={(e) => e.stopPropagation()}>{u.email}</td>
                <td className="px-4 py-2 font-mono whitespace-nowrap">{u.phone || <span className="text-[#6B7280]">—</span>}</td>
                <td className="px-4 py-2 font-mono"><span className="inline-flex items-center gap-1">{u.projects} <ChevronRight className="w-3.5 h-3.5 text-[#6B7280]" /></span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
